import { ActivityMessageData } from './models/activity-message-data';

export class ActivityEventStack {
  private stack: ActivityMessageData[] = [];

  pushEvents(data: ActivityMessageData[]): void {
    data.sort((a, b) => ActivityEventStack.getDate(b) - ActivityEventStack.getDate(a));
    this.stack.push(...data);
  }

  popDueEvents(now: Date): ActivityMessageData[] {
    const dueEvents: ActivityMessageData[] = [];

    while (
      this.hasEvents() &&
      new Date(ActivityEventStack.getDate(this.stack[this.stack.length - 1])) <= now
    ) {
      const eventDue = this.stack.pop();
      if (eventDue) {
        dueEvents.push(eventDue);
      }
    }
    return dueEvents;
  }

  hasEvents(): boolean {
    return this.stack.length > 0;
  }

  private static getDate(data: ActivityMessageData) {
    return data.displayedAt ?? data.createdAt;
  }
}
